module.exports = __webpack_public_path__ + "static/media/18.b9bd3df3.png";